import {
  getConditionalDiscountedVariantOffer,
  getVariantOffer,
  GetVariantOfferArgs,
  getVariantOffersByFilter,
} from './utils';

export const useVariantOffers = ({
  product,
  imageDomainPath,
  itemCountry,
  formatMessage,
}: Omit<GetVariantOfferArgs, 'variant'>) => {
  const isConditionalDiscount = (variant) =>
    !!variant.attributes.ConditionalVoucherDiscount;

  const discountedVariantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getConditionalDiscountedVariantOffer,
    filterCondition: isConditionalDiscount,
  });

  const variantOffers = getVariantOffersByFilter({
    product,
    imageDomainPath,
    itemCountry,
    formatMessage,
    offerCallback: getVariantOffer,
  });

  return { discountedVariantOffers, variantOffers };
};
